import type { ReactNode } from 'react';

/**
 * Envoltura común de las tarjetas de esta pantalla.
 *
 * 🔴 Usa `glass`, la primitiva de tarjeta del resto de la aplicación, en vez del gris plano que
 * tenía este tab. Era la queja concreta: la pantalla «no empata en colores ni formas» porque se había
 * inventado su propia tarjeta (`--bg-secondary`, sin borde ni sombra) mientras todo el panel de
 * administración usa cristal con sombra.
 */
export function ConfigCard({
  icono, titulo, descripcion, pie, isWide, children,
}: {
  icono: string;
  titulo: string;
  descripcion?: string;
  pie?: ReactNode;
  /** Ocupa el ancho completo de la grilla (tarjetas con varios bloques, que a una columna quedan larguísimas). */
  isWide?: boolean;
  children: ReactNode;
}) {
  return (
    <section className={`glass jobs-card${isWide ? ' jobs-card--wide' : ''}`}>
      <header className="jobs-card-header">
        <span className="jobs-card-name">
          <i className={`fas ${icono}`} aria-hidden="true" /> {titulo}
        </span>
      </header>

      {descripcion && <p className="jobs-card-hint">{descripcion}</p>}

      {children}

      {pie}
    </section>
  );
}

/** Aviso de éxito / error al pie de una tarjeta, con los colores del sistema. */
export function AvisoDeGuardado({ aviso, error }: { aviso: string | null; error: string | null }) {
  return (
    <>
      {error && <p className="jobs-alert jobs-alert--bad" role="alert">{error}</p>}
      {aviso && <p className="jobs-alert jobs-alert--ok" role="status">{aviso}</p>}
    </>
  );
}
